declare global {
  interface Window {
    gtag: (command: string, ...args: any[]) => void;
    dataLayer: any[];
  }
}

export const trackEvent = (
  eventName: string,
  params?: Record<string, string | number | boolean>
) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  } else {
    console.debug('Analytics:', eventName, params);
  }
};

export const ANALYTICS_EVENTS = {
  // Landing Page
  CLICK_GET_STARTED: 'click_get_started',
  CLICK_TRY_DEMO: 'click_try_demo',
  
  // Auth
  LOGIN: 'login',
  LOGIN_SUCCESS: 'login_success',
  SIGNUP: 'signup',
  SIGNUP_SUCCESS: 'signup_success',
  
  // Core Actions
  CREATE_RETRO: 'create_retro',
  CREATE_TEAM: 'create_team',
  EXPORT_REPORT: 'export_report',
  ADD_ACTION_ITEM: 'add_action_item',
  ADD_FEEDBACK: 'add_feedback',
  CHANGE_PHASE: 'change_phase',
  INVITE_MEMBER: 'invite_member',
  
  // Session Lifecycle
  START_SESSION: 'start_session',
  END_SESSION: 'end_session',
  DELETE_SESSION: 'delete_session',
  
  // Upgrade
  CLICK_UPGRADE: 'click_upgrade',
} as const;
